import { useReducer } from 'react';

function useForceUpdate() {
  const [, forceUpdate] = useReducer(() => ({}), {});
  return forceUpdate;
}

export default useForceUpdate;